import { render, staticRenderFns } from "./Else.vue?vue&type=template&id=19f83334&"
var script = {}
import style0 from "./Else.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports